export const ages = [
  { key: 18, label: '18岁' },
  { key: 19, label: '19岁' },
  { key: 20, label: '20岁' },
  { key: 21, label: '21岁' },
  { key: 22, label: '22岁' },
  { key: 23, label: '23岁' },
  { key: 24, label: '24岁' },
  { key: 25, label: '25岁' },
  { key: 26, label: '26岁' },
  { key: 27, label: '27岁' },
  { key: 28, label: '28岁' },
  { key: 29, label: '29岁' },
  { key: 30, label: '30岁' },
  { key: 31, label: '31岁' },
  { key: 32, label: '32岁' },
  { key: 33, label: '33岁' },
  { key: 34, label: '34岁' },
  { key: 35, label: '35岁' },
  { key: 36, label: '36岁' },
  { key: 37, label: '37岁' },
  { key: 38, label: '38岁' },
  { key: 39, label: '39岁' },
  { key: 40, label: '40岁' },
  { key: 41, label: '41岁' },
  { key: 42, label: '42岁' },
  { key: 43, label: '43岁' },
  { key: 44, label: '44岁' },
  { key: 45, label: '45岁' },
  { key: 46, label: '46岁' },
  { key: 47, label: '47岁' },
  { key: 48, label: '48岁' },
  { key: 49, label: '49岁' },
  { key: 50, label: '50岁' },
  { key: 51, label: '51岁' },
  { key: 52, label: '52岁' },
  { key: 53, label: '53岁' },
  { key: 54, label: '54岁' },
  { key: 55, label: '55岁' },
  { key: 56, label: '56岁及以上' }
]

export const ios_version = [
  { key: '8', label: '8.x+' },
  { key: '9', label: '9.x+' },
  { key: '10', label: '10.x+' },
  { key: '11', label: '11.x+' },
  { key: '12', label: '12.x+' },
  { key: '13', label: '13.x+' },
  { key: '14', label: '14.x+' }
]

export const android_version = [
  { key: '4', label: '4.x+' },
  { key: '5', label: '5.x+' },
  { key: '6', label: '6.x+' },
  { key: '7', label: '7.x+' },
  { key: '8', label: '8.x+' },
  { key: '9', label: '9.x+' },
  { key: '10', label: '10.x+' },
  { key: '11', label: '11.x+' }
]
